import {Card, Form, Input, Select, Spin} from 'antd';
import React from "react";
import {sanitizeFieldName} from "../../util/methods";

const {TextArea} = Input;

class Create extends React.Component {

  componentDidMount() {
    const {match, fetch} = this.props;
    if(match.params && match.params.id) {
      fetch(match.params.id);
    }
  }

  render() {
    const {getFieldDecorator} = this.props.form;
    const {data, loading, filters, title, resource} = this.props;
    console.log(data);
    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">

            <Form.Item key={'module'} label={'Module'}>
              {getFieldDecorator('module', {
                rules: [{required: true, message: 'Module is required!'}],
                initialValue: data && data.module || ''
              })(<Input disabled={false}/>)
              }
            </Form.Item>

            <Form.Item key={'event'} label={'Event'}>
              {getFieldDecorator('event', {
                rules: [{required: true, message: 'Event is required!'}],
                initialValue: data && data.event && data.event.name || ''
              })(<Input disabled={false}/>)
              }
            </Form.Item>

            <Form.Item key={'eventType'} label={'Event Type'}>
              {getFieldDecorator('eventType', {
                rules: [{required: true, message: 'Event Type is required!'}],
                initialValue: data && data.eventType || ''
              })(<Input disabled={false}/>)
              }
            </Form.Item>

            <Form.Item key={'notificationRequest'} label={'Notification Request'}>
              {getFieldDecorator('notificationRequest', {
                initialValue: data && data.notificationRequest && JSON.stringify(data.notificationRequest, null, 2) || ''
              })(<TextArea disabled={false} autoSize={{ minRows: 4, maxRows: 10 }}/>)
              }
            </Form.Item>

            <Form.Item key={'notificationResponse'} label={'Notification Response'}>
              {getFieldDecorator('notificationResponse', {
                initialValue: data && data.notificationResponse && JSON.stringify(data.notificationResponse, null, 2) || ''
              })(<TextArea disabled={false} autoSize={{ minRows: 6, maxRows: 15 }}/>)
              }
            </Form.Item>

            {Object.keys(filters).map((item) => {
              if(filters[item].type === 'Array' && item === 'notificationType') {
                return <Form.Item key={item} label={sanitizeFieldName(item)}>
                  {getFieldDecorator(item, {
                    rules: [{required: true, message: `${sanitizeFieldName(item)} is required!`}],
                    initialValue: (data && data[item]) ? data[item] : []
                  })(<Select
                    mode="multiple"
                    style={{width: '100%'}}
                    placeholder="Please select"
                    disabled={true}
                    onChange={this.handleNotificationTypeChange}
                  >
                    {filters[item] && filters[item].options && filters[item].options.enum && filters[item].options.enum.map(item =>
                      <Select.Option key={item}
                                     value={item}>{item}</Select.Option>)}
                  </Select>)
                  }
                </Form.Item>
              }
              return null;
            })}
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create(
  {
    name: 'global_state',
    onFieldsChange(props, changedFields) {
      props.onChange(changedFields);
    }
    ,
  }
)(Create);

export default CreateForm;
